import { getProfileValues as getValues } from 'utils/profile-stages';
import Component from './component';
import fields from './fields';
import schema from './schema';
import { TITLE, DESCRIPTION } from './constants';

export default {
  title: TITLE,
  description: DESCRIPTION,
  component: Component,
  getValues,
  fields,
  schema,
};
